import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from "../services/authentication.service";

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

// import { EventBusService } from '../_shared/event-bus.service';
// import { EventData } from '../_shared/event.class';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private authService: AuthenticationService,
  ) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
        withCredentials: false,
    });

    return next.handle(req).pipe(
        catchError((error): Observable<HttpEvent<any>> => {
            if (
                error instanceof HttpErrorResponse &&
                !req.url.includes('/signin') &&
                error.status === 401
            ) {
                return this.handle401Error(req, next);
            }

            return throwError(() => error);
        })
    );
}

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      // if the user is authenticated, refresh the token
      if (this.authService.getUser() !== null) {
        return this.authService.refreshToken().pipe(
          switchMap(() => {
            this.isRefreshing = false;
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${this.authService.getUser()?.token}`,
              },
            });
            return next.handle(request);
          }),
          catchError((error) => {
            this.isRefreshing = false;

            if (error.status == '403') {
              this.authService.logout();
            }

            return throwError(() => this.authService.logout());
          })
        );
      }
    }

    return next.handle(request);
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];